import { useRef } from "react";
import { Event } from "typings";
import { useAnalytics } from "use-analytics";

export function useTrackTimer() {
    const { track } = useAnalytics();
    const startTimeRef = useRef<number>(0);

    const start = () => {
        startTimeRef.current = Date.now();
    }

    const stop = (id: string, payload: Record<string, unknown>) => {
        const duration = (Date.now() - startTimeRef.current) / 1000;
        track(Event.DURATION_TRACE, { id, duration, ...payload });
    }

    return {
        start,
        stop,
    }
}
